import { render, staticRenderFns } from "./Teamee-3.vue?vue&type=template&id=652d600e&scoped=true&"
import script from "./Teamee-3.vue?vue&type=script&lang=js&"
export * from "./Teamee-3.vue?vue&type=script&lang=js&"
import style0 from "./Teamee-3.vue?vue&type=style&index=0&id=652d600e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d600e",
  null
  
)

export default component.exports